import { DBDef_AdvisorSnippet, DBDef_AdvisorWizard, DBDef_FlowSheet, DBDef_LogTemplate, DBDef_NoteTemplate } from '@app/advisor-content-shared';
const conflictResolutionItem_AdvisorWizard = {
    dbKey: DBDef_AdvisorWizard.dbKey,
    collectionRenderer: () => 'Advisor Wizards',
    renderer: wizard => wizard.label,
    filterMapper: wizard => [wizard.label],
};
const conflictResolutionItem_AdvisorSnippet = {
    dbKey: DBDef_AdvisorSnippet.dbKey,
    collectionRenderer: () => 'Advisor Snippets',
    renderer: snippet => snippet.label,
    filterMapper: snippet => [snippet.label],
};
const conflictResolutionItem_LogTemplate = {
    dbKey: DBDef_LogTemplate.dbKey,
    collectionRenderer: () => 'Log Templates',
    renderer: template => template.label,
    filterMapper: template => [template.label],
};
const conflictResolutionItem_NoteTemplate = {
    dbKey: DBDef_NoteTemplate.dbKey,
    collectionRenderer: () => 'Note Templates',
    renderer: template => template.label,
    filterMapper: template => [template.label],
};
const conflictResolutionItem_FlowSheet = {
    dbKey: DBDef_FlowSheet.dbKey,
    collectionRenderer: () => 'Flow Sheets',
    renderer: flowSheet => flowSheet.label,
    filterMapper: flowSheet => [flowSheet.label],
};
export const ConflictResolutionItemGroup_AdvisorContent = [
    conflictResolutionItem_AdvisorWizard,
    conflictResolutionItem_AdvisorSnippet,
    conflictResolutionItem_LogTemplate,
    conflictResolutionItem_NoteTemplate,
    conflictResolutionItem_FlowSheet,
];
//# sourceMappingURL=conflict-resolution-items.js.map